import "./Login.scss";
import PropTypes from "prop-types";
import Button from "core/buttons/button/Button";
import { useState } from "react";
import { FormattedMessage } from "react-intl";

const LoginForm = ({ handleSubmit, response }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  return (
    <div>
      <form onSubmit={handleSubmit} className="form-class">
        <div>
          <label
            className="label label-username"
            htmlFor="input-username"
          ></label>
          <input
            id="input-username"
            name="username"
            className="login-input"
            type="text"
            placeholder="Identifiant"
            value={username}
            data-testid="login"
            autoComplete="username"
            onChange={(e) => setUsername(e.target.value)}
          />
        </div>
        <div>
          <label
            className="label label-password"
            htmlFor="input-password"
          ></label>
          <input
            id="input-password"
            name="password"
            className="password-input"
            type="password"
            placeholder="Mot de passe"
            value={password}
            data-testid="password"
            autoComplete="current-password"
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <div className="error-message">{response?.error || ""}</div>
        <div className="center-button">
          <Button
            size="medium-standard"
            color="pink-gradient"
            type="submit"
            id="validate-login"
          >
            <FormattedMessage
              id={"validate_login"}
              defaultMessage={"Valider"}
            />
          </Button>
        </div>
      </form>
    </div>
  );
};

export default LoginForm;

LoginForm.propTypes = {
  handleSubmit: PropTypes.func,
  response: PropTypes.object,
};
